import { Link, useNavigate } from "react-router-dom";
import { Lightbulb, ArrowRight } from "lucide-react";
import { StepCard } from "@/v2/StepCard";

const Nudge = ({ to, testid, eyebrow, title, body }) => (
  <Link to={to} data-testid={testid} className="card p-5 flex items-center gap-4 chip hover:border-stone-300">
    <span className="flex-1"><span className="eyebrow block">{eyebrow}</span><span className="block font-display text-lg mt-1">{title}</span><span className="block text-xs text-stone-600 mt-0.5">{body}</span></span>
    <ArrowRight className="h-4 w-4 text-stone-500" />
  </Link>
);

// One card, chosen by a fixed priority: ready > re-rate > Sunday review > spark > extra
export function ContextCard({ s, d, setDay, sunday }) {
  const nav = useNavigate();
  if (s.readiness.ready && s.next_phase) return <Nudge to="/journey" testid="context-ready" eyebrow="A new chapter" title={`You're ready for ${s.next_phase.letter} · ${s.next_phase.name}`} body="You decide when. Stay as long as you like." />;
  if (s.needs_rating) return <Nudge to="/journey/progress" testid="context-rerate" eyebrow="Monthly check-in" title="How do you rate your life now?" body="Two minutes. See then vs now for each part of your life." />;
  if (sunday) return <Nudge to="/journey/story" testid="context-review" eyebrow="Sunday" title="Your weekly review" body="What went well, one pattern, one focus for next week." />;
  if (d.spark) return (
    <div className="card p-5 bg-gradient-to-br from-[#FFF8EC] to-white" data-testid="today-spark">
      <span className="eyebrow flex items-center gap-1.5 !text-[#8A5A16]"><Lightbulb className="h-3.5 w-3.5" />An idea for you</span>
      <p className="font-display text-lg mt-2">{d.spark.title}</p>
      <p className="text-sm text-stone-600 mt-1 leading-relaxed">{d.spark.text}</p>
      <button onClick={() => nav("/talk", { state: { opener: `I had an idea for you: ${d.spark.title}. Want to explore it together?` } })} data-testid="today-spark-explore" className="mt-3 text-sm font-semibold underline">Explore this with CAMRYN</button>
    </div>
  );
  if (d.extra) return <StepCard step={d.extra} slot="extra" compact accent="#A8A097" label={d.extra.kind === "challenge" ? "Optional challenge" : d.extra.kind === "discovery" ? "Optional discovery" : "Optional extra"} onDay={setDay} />;
  return null;
}
